export const ariaLabels = {
  lang: "en-GB",
  encryptedCardNumber: {
    label: "Credit or debit card number",
    iframeTitle: "Iframe for card data input field",
  },
  encryptedExpiryDate: {
    label: "Credit or debit card expiration date",
    iframeTitle: "Iframe for card data input field",
  },
  encryptedSecurityCode: {
    label: "Iframe for card data input field",
  },
};

export type AdyenAriaLabels = typeof ariaLabels;
